export type StartProctoringRequestModel = {
  url: string
  token: string
}

export type ProctoringSession = {
  id: string
  score: number
  cheated: boolean
}

export enum ProctoringSessionState {
  CREATED = 1,
  FINISHED = 2,
}

export type ProctoringSessionModel = {
  id: string
  score: number
  cheated: boolean
  state: ProctoringSessionState
  explicitFinish: boolean
}
